<template>
  <div :class="$style.container">
    <div :class="$style.logo">
      <logo-large />
    </div>

    <div :class="$style.information">
      <p>{{ $t('quiсk.and.free.registration') }}</p>
      <p>{{ $t('momentaly.activation.simple.integration') }}</p>
      <p>{{ $t('start.to.receive.transfers') }}</p>
    </div>
  </div>
</template>

<script>
import LogoLarge from 'atoms/logos/LogoLarge';

export default {
  name: 'LoginPoster',
  components: {
    LogoLarge,
  },
};
</script>

<style lang="sass" module>
  .container
    width: 310px
    display: flex
    flex-direction: column

  .logo
    margin-right: 110px
    display: flex

    svg
      width: 100%
      height: 100%

  .information
    margin-top: 96px
    padding-right: 40px

    p
      font-weight: 500
      font-size: 14px
      line-height: 18px
      color: #fff
      opacity: .75

      &:not(:last-child)
        margin: 0 0 20px
</style>
